var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('div',{staticClass:"user-intro"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$translate('INTRODUCE_MYSELF'))}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.userIntro))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }